const CompanyBusinessArea = {

    // FIELDS
    "company": "شركة",
    "name": "الاسم",
    "description": "الوصف",
    "address": "العنوان",
    "code": "الكود",
    "postal_code": "الرمز البريدي",
    "email": "البريد الإلكتروني",
    "phone": "رقم الهاتف",
    "mobile_no": "رقم الجوال",
    "state": "الولاية",
    "city": "المدينة",
    "country": "الدولة",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "bussiness_area": "مجال العمل",

    // ERROR
    "error_company": "اختر الشركة",
    "error_name": "ادخل الاسم",
    "error_description": "ادخل الوصف",
    "error_address": "ادخل العنوان",
    "error_code": "ادخل الكود",
    "error_postal_code": "ادخل الرمز البريدي",
    "error_email": "ادخل البريد الإلكتروني",
    "error_phone": "ادخل رقم الهاتف",
    "error_mobile_no": "ادخل رقم الجوال",
    "error_country": "اختر الدولة",
    "error_state": "اختر الولاية",
    "error_city": "اختر المدينة",
    "error_status": "اختر الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_city": "المدينة",
    "table_mobile_no": "الجوال",
    "table_status": "الحالة",
}

export default CompanyBusinessArea;